import { render, staticRenderFns } from "./CartFrameAssemblyPositionNrInput.vue?vue&type=template&id=4dac60b0&scoped=true"
import script from "./CartFrameAssemblyPositionNrInput.vue?vue&type=script&lang=ts"
export * from "./CartFrameAssemblyPositionNrInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac60b0",
  null
  
)

export default component.exports